
// verifyCondition_draggingView: Esta función verifica si se cumple la condición para que se 
// renderice el componente.
export const verifyCondition_draggingView = ( filesSelected, isDragging ) => {
    let condition = (filesSelected.length === 0 && isDragging);
    return condition;
}
